import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import styles from './new-badge-modal.styl'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import config from '../../../config'
import { apiBadges } from '../../../helpers/decorators/api/dashboard'
import { getActivityBadgeColor, getBadgeIconImg } from '../../../helpers/badgeHelper'

@apiBadges({ loadBadges: true })
export default class NewBadgeModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    badge: PropTypes.object,
    badges: PropTypes.object.isRequired,
    data: PropTypes.object
  }

  getNextBadge = (data, badges) =>{

    const badgeName = get(data, 'data.badge.name.value')

    const badgeOrder = get(data, 'data.badge.order')

    const badgesByName =  badges && get(badges[badgeName], 'badges')

    const nextBadge = badgesByName && badgesByName.length > 0 && badgesByName.filter(b => b.order === badgeOrder + 1)

    return nextBadge && nextBadge[0]
  }

  render() {
    const { modalId, data, badges } = this.props

    const awardId = get(data, 'data.award.id')

    const activityId = get(data, 'data.activity.id')

    const nextBadge = this.getNextBadge(data, get(badges, 'badges'))

    const color = getActivityBadgeColor(get(data, 'data.activity'))

    const badgeIconImg = get(data, 'data.award') && get(data, 'data.badge') && getBadgeIconImg(get(data, 'data.award'), get(data, 'data.badge'), true)

    return (
      <MaterialModal.Body id={modalId} narrow noHeader>
        <MaterialModal.Content noFooter noHeader>

          <div className={styles.wrapper}>
          <div className={`${styles.badgeIcon}`}>
            <img src={`data:image/png;base64, ${badgeIconImg}`} />
          </div>
          <div className={`${styles.congratulation} ${styles[color]}`}>
          <FormattedMessage id='label.congratulation' defaultMessage='Congratulation!' />
          </div>
          <br />
          <div className={styles.text}>
          <FormattedMessage id='label.just_become' defaultMessage='You have a just become' />
          </div>

          <div className={`${styles.badge} ${styles[color]}`}>
            <span>{get(data, 'data.badge.name.translationText')}</span>
            <div className={styles.subTitle}><FormattedMessage id='label.level' defaultMessage='Level' /></div>
            <span>{get(data, 'data.badge.badgeLevel.translationText')}</span>
          </div>

            {nextBadge && (<div>
              <div className={styles.text}>
                  <FormattedMessage id='label.next_bagde_level_is' defaultMessage='next level is'/>
              </div>

                <div className={styles.nextBadge}>
                  <span>{get(nextBadge, 'badgeLevel.translationText')}</span>
                </div>

              <div className={styles.desc}>
                <FormattedMessage
                  id='label.available_badges_desc'
                  defaultMessage='You can list all your existing and available badges in the Badge tab on your activity detail'
                  tagName='p'
                />
              </div>
            </div>)}

          <div className={styles.link}>
            <Link to={`${config.publicPath}/dashboard/awards/${awardId}/activity/${activityId}/badges`}>
              <FormattedMessage  id='label.see_all_badges' defaultMessage='See all badges.'/>
            </Link>
          </div>

          </div>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
